/**
 * Updates the Add to Cart button price based on Recharge subscription selection
 */
(function() {
  'use strict';

  function updateButtonPrice(price, isSubscription) {
    if (!price) return;
    
    document.querySelectorAll('.button-price').forEach(function(buttonPrice) {
      const priceContainer = buttonPrice.querySelector('.price');
      if (priceContainer) {
        const priceRegular = priceContainer.querySelector('.price__regular');
        const priceSale = priceContainer.querySelector('.price__sale');
        const regularPriceItem = priceContainer.querySelector('.price__regular .price-item--regular') ||
                                 priceContainer.querySelector('.price-item--regular');
        const salePriceItem = priceContainer.querySelector('.price-item--sale.price-item--last');

        // Capture the product's true on-sale state once (from the server-rendered class)
        // before any toggle mutates it, so one-time can still show the strikethrough.
        if (priceContainer.dataset.serverOnSale === undefined) {
          priceContainer.dataset.serverOnSale = priceContainer.classList.contains('price--on-sale') ? '1' : '0';
        }
        const productOnSale = priceContainer.dataset.serverOnSale === '1';

        if (isSubscription) {
          // Subscription selected - show sale section with subscription price
          priceContainer.classList.add('price--on-sale');
          if (priceRegular) priceRegular.style.display = 'none';
          if (priceSale) priceSale.style.display = 'block';
          if (salePriceItem) salePriceItem.textContent = price;
          else if (regularPriceItem) regularPriceItem.textContent = price;
        } else if (productOnSale && priceSale && salePriceItem) {
          // One-time on a sale product - keep the strikethrough (compare-at struck + one-time price).
          priceContainer.classList.add('price--on-sale');
          if (priceRegular) priceRegular.style.display = 'none';
          priceSale.style.display = 'block';
          salePriceItem.textContent = price;
        } else {
          // One-time, not on sale - show the plain regular price.
          priceContainer.classList.remove('price--on-sale');
          if (priceRegular) priceRegular.style.display = 'block';
          if (priceSale) priceSale.style.display = 'none';
          if (regularPriceItem) regularPriceItem.textContent = price;
        }
      } else {
        const priceItem = buttonPrice.querySelector('.price-item--sale') || 
                          buttonPrice.querySelector('.price-item--last') || 
                          buttonPrice.querySelector('.price-item');
        if (priceItem) priceItem.textContent = price;
        else buttonPrice.textContent = price;
      }
    });
  }

  function getSubscriptionPrice() {
    // Wait for config to be available
    if (!window.SubscriptionWidgetConfig || !window.SubscriptionWidgetConfig.formattedPrices) {
      return null;
    }

    // Find all forms and look for selling_plan input
    const forms = document.querySelectorAll('form[data-type=add-to-cart-form]');
    let sellingPlanInput = null;
    let form = null;
    
    // Check all forms for selling_plan input
    for (let i = 0; i < forms.length; i++) {
      const input = forms[i].querySelector('input[name="selling_plan"]');
      if (input && input.value) {
        sellingPlanInput = input;
        form = forms[i];
        break;
      }
    }
    
    if (!sellingPlanInput || !sellingPlanInput.value || !form) {
      return null;
    }

    const sellingPlanId = parseInt(sellingPlanInput.value, 10);
    const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
    
    if (!sellingPlanId || !variantId) return null;

    // Check if variant exists in config
    const variantPrices = window.SubscriptionWidgetConfig.formattedPrices[variantId];
    if (!variantPrices || !variantPrices.sellingPlans) return null;

    // Get price for the selected selling plan
    const planPrice = variantPrices.sellingPlans[sellingPlanId];
    if (!planPrice || !planPrice.price) return null;
    
    // Return price (may include currency suffix like "CAD" or "USD")
    return planPrice.price;
  }

  function getRegularPrice() {
    // Prefer the button's own price element: it's always rendered (even when the main
    // `.price.price--large` block is disabled on the PDP) and its regular-price item is
    // never overwritten by subscription selection, so it's the reliable one-time price.
    const buttonPrice = document.querySelector('.button-price');
    if (buttonPrice) {
      const regItem = buttonPrice.querySelector('.price__regular .price-item--regular') ||
                      buttonPrice.querySelector('.price-item--regular');
      if (regItem) return regItem.textContent.trim();
    }

    // Fallback: main product price section, if present on the page.
    const priceSection = document.querySelector('.price.price--large');
    if (priceSection) {
      if (priceSection.classList.contains('price--on-sale')) {
        const salePriceItem = priceSection.querySelector('.price-item--sale.price-item--last');
        if (salePriceItem) return salePriceItem.textContent.trim();
      }
      const regularPriceItem = priceSection.querySelector('.price__regular .price-item--regular') ||
                              priceSection.querySelector('.price-item--regular') ||
                              priceSection.querySelector('.price-item');
      if (regularPriceItem) return regularPriceItem.textContent.trim();
    }

    return null;
  }

  function updatePrice() {
    const subscriptionPrice = getSubscriptionPrice();
    
    // Only update if we have a subscription price
    // Don't touch products without subscriptions (they may have sales)
    if (subscriptionPrice) {
      updateButtonPrice(subscriptionPrice, true);
    } else {
      // Check if there's a selling_plan input at all (even if empty)
      // If no input exists, this product doesn't have subscriptions, so don't touch it
      const forms = document.querySelectorAll('form[data-type=add-to-cart-form]');
      let hasSellingPlanInput = false;
      for (let i = 0; i < forms.length; i++) {
        if (forms[i].querySelector('input[name="selling_plan"]')) {
          hasSellingPlanInput = true;
          break;
        }
      }
      
      // Only update to regular price if this product has subscription options
      // (meaning user switched from subscription to one-time)
      if (hasSellingPlanInput) {
        const regularPrice = getRegularPrice();
        if (regularPrice) {
          updateButtonPrice(regularPrice, false);
        }
      }
    }
  }

  function init() {
    // Find all forms, prefer main product form over quick-add
    const forms = document.querySelectorAll('form[data-type=add-to-cart-form]');
    if (forms.length === 0) {
      setTimeout(init, 500);
      return;
    }

    // Watch all forms for selling_plan input changes
    forms.forEach(function(form) {
      const observer = new MutationObserver(function(mutations) {
        let shouldUpdate = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1 && (node.name === 'selling_plan' || node.querySelector?.('input[name="selling_plan"]'))) {
                shouldUpdate = true;
              }
            });
          }
          if (mutation.type === 'attributes' && mutation.target.name === 'selling_plan') {
            shouldUpdate = true;
          }
        });
        if (shouldUpdate) setTimeout(updatePrice, 200);
      });
      
      observer.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      });

      form.addEventListener('change', function(e) {
        if (e.target.name === 'selling_plan' || e.target.closest('recharge-subscription-widget')) {
          setTimeout(updatePrice, 200);
        }
      });
    });

    // Watch Recharge widget
    const widget = document.querySelector('recharge-subscription-widget');
    if (widget) {
      widget.addEventListener('change', function() {
        setTimeout(updatePrice, 300);
      });
      
      const widgetObserver = new MutationObserver(function() {
        setTimeout(updatePrice, 300);
      });
      widgetObserver.observe(widget, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }

    // Listen for clicks on Recharge widget buttons
    const container = document.querySelector('.recharge-subscription-widget, .shopify-block.recharge-subscription-widget');
    if (container) {
      container.addEventListener('click', function(e) {
        // Check if click is on subscription-related elements
        if (e.target.closest('button') || e.target.closest('[role="button"]') || e.target.closest('input[type="radio"]')) {
          setTimeout(updatePrice, 300);
        }
      });
    }

    // Poll for changes (check all forms)
    let lastValue = '';
    setInterval(function() {
      let currentValue = '';
      forms.forEach(function(form) {
        const input = form.querySelector('input[name="selling_plan"]');
        if (input) {
          // Empty string means one-time, any value means subscription
          currentValue = input.value || 'one-time';
        } else {
          // No input means one-time purchase
          currentValue = 'one-time';
        }
      });
      
      if (currentValue !== lastValue) {
        lastValue = currentValue;
        updatePrice();
      }
    }, 300);

    // Wait for config and initial update
    function waitForConfig() {
      if (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.formattedPrices) {
        setTimeout(function() {
          updatePrice();
          setTimeout(updatePrice, 1000);
          setTimeout(updatePrice, 2000);
        }, 800);
      } else {
        setTimeout(waitForConfig, 200);
      }
    }
    waitForConfig();
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 300);
  }

})();
